import { render, staticRenderFns } from "./PortCheckModal.vue?vue&type=template&id=580cb5c4"
import script from "./PortCheckModal.vue?vue&type=script&lang=js"
export * from "./PortCheckModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports